import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, bonuses } from '../data/atlas';
export function BonusSection() {
  return <section className="border-y-4 border-teal/30 bg-ice/40 px-4 py-6 sm:py-8" data-id="element-18" data-mp="1ofc8y3t0d9lp">
      <div className="mx-auto max-w-4xl" data-id="element-19" data-mp="22ebuh2l858dn">
        <h2 className="text-center text-2xl leading-none text-navy sm:text-3xl" data-id="element-20" data-mp="22dah2rgqk9sr">
          🎁 5 Premium Bonuses Included
        </h2>

        <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="1annuvuz78b23">
          {bonuses.map(bonus => <a key={bonus.num} href={CHECKOUT_URL} className="flex flex-col rounded-lg border border-teal/40 bg-white p-4 shadow-sm transition-colors duration-150 hover:border-teal" data-id="element-22" data-mp="15qfbjr2be0z9">
              <p className="text-xs font-extrabold uppercase tracking-wide text-teal" data-id="element-23" data-mp="1enxyx23fkreb">
                🎁 Bonus {bonus.num}
              </p>
              <h3 className="mt-1 text-sm leading-tight text-navy sm:text-base" data-id="element-24" data-mp="mzeej8kr8fic">
                {bonus.title}
              </h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-slate2" data-id="element-25" data-mp="29rbhsysepbzo">
                {bonus.body}
              </p>
              <p className="mt-auto pt-2 text-xs font-extrabold uppercase tracking-wide text-navy" data-id="element-26" data-mp="2ep36zl1o2k06">
                {bonus.kicker}
              </p>
            </a>)}
        </div>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-27" data-mp="2og7puvugqp0a">
          🦷 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}